import React, { useState } from "react";

import { produce, useElementSize, useTranslation } from "@opendash/core";

import {
  Button,
  Col,
  Divider,
  Drawer,
  Row,
  Select,
  SelectProps,
  Switch,
} from "antd";

import { Icon } from "@opendash/icons";
import { CustomParseFieldProps } from "@opendash/plugin-parse";
import { Description } from "@opendash/ui";
import { Typography } from "antd/lib";
import dayjs from "dayjs";

const IntervalSelect = (props: SelectProps & { setValue: (e) => void }) => {
  const t = useTranslation();
  return (
    <Select
      style={props.style}
      value={props.value}
      onChange={(e) => {
        props.setValue(e);
      }}
    >
      <Select.Option value={60}>{t("miaas:gbfs.refresh.minute")}</Select.Option>
      <Select.Option value={60 * 15}>
        {t("miaas:gbfs.refresh.minute15")}
      </Select.Option>
      <Select.Option value={60 * 60}>
        {t("miaas:gbfs.refresh.hourly")}
      </Select.Option>
      <Select.Option value={60 * 60 * 24}>
        {t("miaas:gbfs.refresh.daily")}
      </Select.Option>
    </Select>
  );
};
export const GBFSSensorsCustomRefreshSelect = (
  props: CustomParseFieldProps<any>
) => {
  if (!props.setValue) {
    return (
      dayjs
        //@ts-ignore
        .duration(props.value * 1000)
        .locale("de-de")
        .humanize()
    );
  }

  return (
    <IntervalSelect
      setValue={props.setValue}
      value={props.value}
    ></IntervalSelect>
  );
};

export const GBFSDataSelector = (props: CustomParseFieldProps<any>) => {
  const t = useTranslation();
  const { value, setValue, fieldname, parseObject } = props;
  const map = React.useRef(null);

  const container = React.useRef(null);
  const drawerContent = React.useRef(null);
  const [open, setOpen] = useState(false);
  const { width, height } = useElementSize(container);
  const StandardFields = (fieldProps: { fieldname: string }) => {
    const [pObject, setPObject] = useState(props.parseObject.toJSON());
    const { fieldname: cField } = fieldProps;
    return (
      <Col span={24}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <Switch
            checkedChildren={<Icon icon="fa:check"></Icon>}
            unCheckedChildren={<Icon icon="fa:do-not-enter"></Icon>}
            checked={pObject[cField].enabled}
            onChange={(checked) => {
              props.parseObject.set(
                cField,
                produce(props.parseObject.get(cField), (draft) => {
                  draft.enabled = checked;
                })
              );
              props.parseObject.save().then(() => {
                setPObject(props.parseObject.toJSON());
              });
            }}
          ></Switch>
          <IntervalSelect
            style={{ flexGrow: 1 }}
            value={pObject[cField].saveInterval / 1000}
            setValue={(e) => {
              props.parseObject.set(
                cField,
                produce(props.parseObject.get(cField), (draft) => {
                  draft.saveInterval = e * 1000;
                })
              );
              props.parseObject.save().then(() => {
                setPObject(props.parseObject.toJSON());
              });
            }}
          />
        </div>
        <Description style={{ margin: 0 }}>
          {t("miaas:gbfs.sensors." + cField)}
        </Description>
      </Col>
    );
  };

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
      >
        {t("miaas:gbfs.sensors.edit")}
      </Button>
      <Drawer
        open={open}
        placement="right"
        width="25%"
        title={t("miaas:gbfs.sensors.edit")}
        onClose={() => setOpen(false)}
      >
        <Row gutter={16}>
          <Col
            span={4}
            style={{
              textAlign: "center",
              fontSize: "4em",
              color: "rgba(0,0,0,0.2)",
            }}
          >
            <Icon icon="fa:question"></Icon>
          </Col>
          <Col span={20} style={{ textAlign: "center" }}>
            {t("miaas:gbfs.sensors.hint.description")}
          </Col>
        </Row>
        <Divider>
          <Typography.Text type="secondary">
            {t("miaas:gbfs.sensors.settings")}
          </Typography.Text>
        </Divider>
        <Row gutter={16}>
          <StandardFields fieldname="allBikesGeo" />
        </Row>
        <Divider />
        <Row gutter={16}>
          <StandardFields fieldname="allStationGeo" />
        </Row>
        <Divider />
        <Row gutter={16}>
          <StandardFields fieldname="globalCounts" />
        </Row>
        <Divider />
        <Row gutter={16}>
          <StandardFields fieldname="zoneCountsSave" />
        </Row>
        <Divider />
        <Row gutter={16}>
          <StandardFields fieldname="allBikesTrips" />
        </Row>
        <Divider />
      </Drawer>
    </>
  );
};
